'use strict';
import "regenerator-runtime/runtime";
let React = require('react');
let BaseComponent = require('../../shared/base');
let client = require('../../../../sdk/client');

class AvailabiltyModalComponent extends BaseComponent{
    constructor(props) {
        super(props)

        this.state= {
            sucursalesCt: [],
            stockLider: undefined
        }

        this.hasUserConfig = undefined;
        this.extendAvailability = undefined;
    }

    componentDidMount() {
        if (this.props.item_state != null)
        {
            this.userAddress =this.getCookie('SelectedAddress');
            this.props.item_state.address= this.userAddress;
            this.getTableData();
        }
    }

    hideTable() {
        document.getElementById("modal-availability").style.display = "none";
    }

    getCookie(name){
        if(typeof window !== 'undefined'){
            var value = '; ' + document.cookie;
            var parts = value.split('; ' + name + '=');
            if (parts.length === 2) {
                return parts.pop().split(';').shift();
            }
        }
    }

    modalsorting(almacenes, userConfig) {
        if (userConfig.TotalRecords > 0) {
            let myRegion = almacenes.Records.find(x => x.Nombre == userConfig.Records[0].AlmacenFacturacion);

            let almacenesdemiregion = []
            almacenes.Records.forEach(x => {
                if (x.Region == myRegion.Region) {
                    almacenesdemiregion.push(x);
                }
            });

            let almacenesdenomiregion = []
            almacenes.Records.forEach(x => {
                if (x.Region != myRegion.Region) {
                    almacenesdenomiregion.push(x);
                }
            });

            almacenesdemiregion.sort((x, y) => this.NameSortFunction(x, y));
            almacenesdenomiregion.sort((x, y) => this.NameSortFunction(x, y));

            let ordenamiento = almacenesdemiregion.concat(almacenesdenomiregion);

            return ordenamiento;

        } else {
            let ordenamiento = almacenes.Records.sort((x, y) => this.NameSortFunction(x, y));

            return ordenamiento;
        }

    }

    NameSortFunction(x, y) {
        if (x.Nombre > y.Nombre) {
            return 1;
        }
        if (x.Nombre < y.Nombre) {
            return -1;
        }
        // x must be equal to y
        return 0;
    }

    getStockAvailability(depotId) {
        let availability = 0;
        let depot = this.state.stockLider.find(x => x.DepotId == Number(depotId));

        if (depot != undefined && this.hasUserConfig == true) {
            //render just if is in the config table
            if (this.extendAvailability.includes(`${depot.DepotId}`)) {
                availability = depot.Availability;
            }
        }
        else if (depot != undefined && this.hasUserConfig == false) {
            availability = depot.Availability
        } else {
            availability = 0;
        }

        return availability;
    }

    getTableData() {
        const promiseSucursales = new Promise((resolve, reject) => {
            const options = {
                pluginId: process.env.ADMINISTRACION_ALMACENES,
                tableName: "Almacenes",
                query: [
                    {
                        Name: 'IsActive',
                        Operator: "eq",
                        Value: "true"
                    }
                ]
            };

            client.CustomTables.searchCustomTable(options, function (err, result) {
                resolve(result);
            });
        });

        const promiseUserConfiguration = new Promise((resolve, reject) => {
            const options = {
                pluginId: process.env.ADMINISTRACION_ALMACENES,
                tableName: "ConfiguracionUsuario",
                query: [{
                    Name: "UserId",
                    Operator: "equal",
                    Value: this.props.user.ID
                },
                {
                    Name: "AddressId",
                    Operator: "equal",
                    Value: this.userAddress
                }
            ]
            };
            client.CustomTables.searchCustomTable(options, function (err, result) {
                resolve(result);
            });
        });

        //TODO: poner en partcode del CF correspondiente
        const requestBody = {
            "operatingUnitId": 446,// esto debe ir fijo
            //"depotID": 7201, // esto se debe de quitar en una proximo update de endpoint
            "partsCode": [
                {
                    "partCode": this.props.partNumber // TODO: esto debe ser una propiedad del item
                }
            ]
        };

        const promiseapilider = client.Availability.GetAvalability(requestBody);



        Promise.all([promiseSucursales, promiseapilider, promiseUserConfiguration]).then(response => {
            let sucursales = this.modalsorting(response[0], response[2]);
            let btcsucursales=response[0].Records;
            let avalabilityesTotal = 0;

                let avalabilityes = response[1].Parts[0].Availabilitys;

                avalabilityes.forEach(element=>{
                    avalabilityesTotal = element.Availability + avalabilityesTotal;
                })
                let rows = '';
                if (response[2].TotalRecords == 1 &&  response[1].Parts != undefined) {
                    let userConfig = response[2].Records[0];
                    let liderPart = response[1].Parts[0]; // debe ser solo una porque se busca sdolamente esta
                    this.state.stockLider= response[1].Parts[0].Availabilitys;
                    this.extendAvailability = userConfig.VisibilidadExtentidaLiderId.split(',');
                    this.hasUserConfig = true;
                }else if(response[2].TotalRecords == 0 &&  response[1].Parts != undefined){
                    let userConfig = response[2].Records[0];
                    this.state.stockLider= response[1].Parts[0].Availabilitys;
                    this.hasUserConfig = false;
                    this.extendAvailability = [];
                }            
                //const userIsB2C = this.props.user.CustomFields[4].Values[0] === "B2C";
                ///const userIsB2C = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";            
                //Cart funcionality
                var userIsB2C = true;
                if(this.props.user.CustomFields) {
                    userIsB2C = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";
                } 
                        
                if (userIsB2C) 
                {
                    btcsucursales.forEach(element=>{
                        let stock = this.getStockAvailability(element.LiderId);
                        if(stock>0){
                            rows += `<tr key=${element.LiderId} id=${element.LiderId}>
                            <td id=${element.LiderId}>${element.Nombre}</td>
                            <td id="availability">${stock}</td>
                            </tr>`
                        }
                    })
                    if (rows.length > 0) {
                        $('#modal-availability #modalBody table>tbody')[0].innerHTML = rows;
                    }
                    else {
                        $('#modal-availability #modalBody table>tbody')[0].innerHTML =`<tr>
                        <td>No hay existencias disponibles.</td>
                        <td>-</td>
                        </tr>`;
                    }
                }
                sucursales.forEach(element => {
                    let stock = this.getStockAvailability(element.LiderId);
                    if (stock >= 0 && this.extendAvailability.includes(`${element.LiderId}`)) {
                        rows += `<tr key=${element.LiderId} id=${element.LiderId}>
                    <td id=${element.LiderId}>${element.Nombre}</td>
                    <td id="availability">${stock}</td>
                    </tr>`
                    }
                });
                if (rows.length > 0) {
                    $('#modal-availability #modalBody table>tbody')[0].innerHTML = rows;
                }
                else {
                    $('#modal-availability #modalBody table>tbody')[0].innerHTML =`<tr>
                    <td>No hay existencias disponibles.</td>
                    <td>-</td>
                    </tr>`;
                }
            
        });
    }

    renderModalPopUp() {
        return (
            <div className="modal fade modal-availability-c" id="modal-availability" tabIndex="-1" role="dialog" aria-labelledby="userEditorLabel" aria-hidden="true" style={{ display: "none" }}>
                <div className="modal-dialog" style={{ width: 800 + 'px' }} role="document">
                    <div className="modal-content" style={{borderRadius: 25+ 'px'}}>
                        <div className="modal-header" style={{ marginLeft: 15 + 'px', marginBottom: -10 + 'px' , borderBottom: 'none'}} >
                            <h5 className="modal-title col-md-11" id="userEditorLabel" style={{ fontWeight: "bold" , fontSize: 23+'px'}} >{this.props.modalHeader}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>

                        <div className="modal-body" id="modalBody" style={{ marginBottom: 25 + 'px', marginLeft: 25 + 'px', marginRight: 25 + 'px' }}>
                            <table className="table">
                                <thead>
                                    <tr style={{ background: "white", borderColor: '#f0f0f0', borderTopStyle:"solid" }}>
                                        <th scope="col">Sucursal</th>
                                        <th scope="col">Existencias</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row">Cargando</th>
                                        <td>-</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <React.Fragment>
                {this.renderModalPopUp()}
            </React.Fragment>
        );
    }
}


module.exports = AvailabiltyModalComponent;